"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var DynamicFieldType;
(function (DynamicFieldType) {
    DynamicFieldType["Text"] = "Text";
    DynamicFieldType["JSON"] = "JSON";
})(DynamicFieldType = exports.DynamicFieldType || (exports.DynamicFieldType = {}));
//# sourceMappingURL=DynamicFieldType.js.map